import React from "react";
import FileDownloadButton from "../../../common/ellipsisText/FileDownloadButton";
import useFolderFiles from "../utils/useFolderFileName";
import { EMPTY_CELL } from "../../../common/constants/constants";

/**
 * Download button for a stored file, named after the file even when the key is a folder. Shows the
 * empty-cell dash when there is nothing to download, or once the folder is known to be empty. The
 * button stays clickable with its fallback label while the name loads, since the download lists the
 * folder itself; only this cell's own in-flight download shows a spinner and stops accepting clicks.
 */
export default function S3FileDownloadButton({available = true, s3Key, bucket, domain, fallback = "File", loading = false, loadingText, onClick}) {
    const { fileName, isEmpty } = useFolderFiles(available ? s3Key : null, bucket, domain);
    if (!available || isEmpty) {
        return EMPTY_CELL;
    }
    return <FileDownloadButton fileName={fileName} fallback={fallback} loading={loading} loadingText={loadingText} onClick={onClick} />;
}
